/*
 * Copyright (c) Worldline 2023.
 */

export const MimeType = {
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    pjpeg: 'image/pjpeg',
    png: 'image/png',
    gif: 'image/gif',
    pdf: 'application/pdf',
    tiff: 'image/tiff'
}
